import { useEffect } from "react";
import { toast } from "react-toastify";
import { useSelector } from "react-redux";
import { notificationSocket } from "../../service/socket/notification.socket";

const NotificationProvider = ({ children }) => {
    const {currentUser}=useSelector((state)=>state.store)
   const adminId=currentUser?.data?.user?._id;
  useEffect(() => {
    if (!adminId) return;

    // Connect socket
    notificationSocket.connect();
    notificationSocket.emit("join", adminId);

    // Handle admin notifications
    const handleNotification = (data) => {
      console.log("🔔 Admin Notification:", data);
      toast.info(data.message, {
        position: "top-right",
        autoClose: 4000,
      });
    };

    notificationSocket.on("admin-notification", handleNotification);

    return () => {
      notificationSocket.off("admin-notification", handleNotification);
      notificationSocket.disconnect();
    };
  }, [adminId]);

  return children;
};

export default NotificationProvider;
